var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { action, observe, makeObservable } from 'mobx';
export class HookerActiveTree {
    parent;
    lifeCycle;
    constructor(parent) {
        makeObservable(this);
        this.parent = parent;
    }
    get app() {
        return this.parent.app;
    }
    nodesDidChange({ oldValue, newValue }) {
        const added = newValue.filter(x => !oldValue.includes(x));
        const removed = oldValue.filter(x => !newValue.includes(x));
        this.notifyAdded(added);
        /*removed.forEach((node: any) => {
          if (node.onDidLeaveActiveTree) {
            node.onDidLeaveActiveTree();
          }
        }); */
    }
    notifyAdded(added) {
        added.forEach((node) => {
            if (node.onDidEnterActiveTree) {
                node.onDidEnterActiveTree();
            }
        });
    }
    enableHook() {
        this.notifyAdded(this.app.exportingTreeNode.allNodes);
        this.lifeCycle = observe(this.app.exportingTree, 'allExportingActors', this.nodesDidChange);
    }
}
__decorate([
    action.bound
], HookerActiveTree.prototype, "nodesDidChange", null);
__decorate([
    action.bound
], HookerActiveTree.prototype, "notifyAdded", null);
__decorate([
    action.bound
], HookerActiveTree.prototype, "enableHook", null);
